var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isIos || _vm.isSafari ? 'default_safari' : 'default',{ref:"process_layer",tag:"component",attrs:{"questions":_vm.questions},on:{"set_event_catcher":function($event){return _vm.$emit('set_event_catcher', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }